import { LogOut, User } from 'lucide-react';

import { Avatar, AvatarFallback } from '@/shared/ui/avatar';
import { Button } from '@/shared/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/shared/ui/card';
import { useSession } from '@/app/providers/session-provider';
import { useRouter } from '@tanstack/react-router';

export interface AccountSummaryProps {
  name?: string | null;
  email?: string | null;
}

export const AccountSummary = ({ name, email }: AccountSummaryProps) => {
  const { signOut } = useSession();
  const router = useRouter();
  const handleSignOut = async () => {
    await signOut();
    router.invalidate();
  };
  return (
    <Card className="overflow-hidden border-border/50 shadow-sm">
      <CardHeader className="flex flex-col gap-5 border-b border-border/60 bg-muted/20 p-5">
        <div className="flex flex-col items-center gap-4">
          <Avatar className="h-20 w-20">
            <AvatarFallback className="bg-primary/10 text-primary">
              <User className="h-8 w-8" />
            </AvatarFallback>
          </Avatar>
          <div className="w-full space-y-1.5 text-center">
            <CardTitle className="text-base font-semibold uppercase tracking-[0.25em] text-foreground">
              {(name ?? '-').toUpperCase()}
            </CardTitle>
            <CardDescription className="break-all text-sm text-muted-foreground/80">
              {email ?? '-'}
            </CardDescription>
          </div>
        </div>
        <Button
          type="button"
          variant="outline"
          className="w-full gap-2 rounded-full px-5 py-2.5 text-sm font-semibold shadow-sm"
          onClick={handleSignOut}
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </Button>
      </CardHeader>
      <CardContent className="p-4 text-sm leading-relaxed text-muted-foreground">
        <p>
          Manage certificates, download proof of completion, and submit
          verification requests.
        </p>
      </CardContent>
    </Card>
  );
};
